import React, { useEffect, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { GetAllPost } from '../services/postservice';
import { GetAllCategory } from '../services/categoryservice';
import { GetAllTags } from '../services/tagservice';
import { GetAllPages } from '../services/pageservice';
function Sitemaps() {
    const [blogs, setBlogs] = useState([]);
    const [tags, setTags] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pages, setPages] = useState([]);

    useEffect(() => {
        fetchBlogs();
        fetchTags();
        fetchCategories();
        fetchPages();
        toast("successMessage");
    }, []);

    const fetchBlogs = async () => {
        const postData = await GetAllPost();
        const jsonPostList = JSON.parse(postData);
        setBlogs(jsonPostList || []);
    };

    const fetchTags = async () => {
        const tagData = await GetAllTags();
        const jsonTagList = JSON.parse(tagData);
        setTags(jsonTagList || []);
    };
    const fetchCategories = async () => {
        const categoryData = await GetAllCategory();
        const jsonCategoryList = JSON.parse(categoryData);
        setCategories(jsonCategoryList || []);
    };

    const fetchPages = async () => {
        const pages = await GetAllPages();
        const jsonList = JSON.parse(pages);
        setPages(jsonList || []);
    };

    const generateBlogSitemap = () => {
        const baseUrl = "https://databeautifier.com/blog";

        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;

        // Add main blog page
        // xml += `  <url>\n`;
        // xml += `    <loc>${baseUrl}</loc>\n`;
        // xml += `    <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>\n`;
        // xml += `    <changefreq>daily</changefreq>\n`;
        // xml += `    <priority>0.9</priority>\n`;
        // xml += `  </url>\n`;

        // Add each blog
        blogs.forEach((blog) => {
            xml += `  <url>\n`;
            xml += `    <loc>${baseUrl}/${blog.paramlink}</loc>\n`;
            xml += `    <lastmod>${blog.posteddate}</lastmod>\n`;
            xml += `  </url>\n`;
        });

        xml += `</urlset>`;

        return xml;
    };

    const generateTagSitemap = () => {
        console.log("tags:", tags);
        const baseUrl = "https://databeautifier.com/tag";

        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;

        // Add main blog page
        // xml += `  <url>\n`;
        // xml += `    <loc>${baseUrl}</loc>\n`;
        // xml += `    <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>\n`;
        // xml += `    <changefreq>daily</changefreq>\n`;
        // xml += `    <priority>0.9</priority>\n`;
        // xml += `  </url>\n`;

        // Add each tags
        tags.forEach((tag) => {
            xml += `  <url>\n`;
            xml += `    <loc>${baseUrl}/${tag.paramlink}</loc>\n`;
            xml += `    <lastmod>${tag.updatedon}</lastmod>\n`;
            xml += `  </url>\n`;
        });

        xml += `</urlset>`;

        return xml;
    };

    const generateCategorySitemap = () => {
        console.log("categories:", categories);
        const baseUrl = "https://databeautifier.com/category";

        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;

        // Add main category page
        // xml += `  <url>\n`;
        // xml += `    <loc>${baseUrl}</loc>\n`;
        // xml += `    <lastmod>${new Date().toISOString().split("T")[0]}</lastmod>\n`;
        // xml += `    <changefreq>daily</changefreq>\n`;
        // xml += `    <priority>0.9</priority>\n`;
        // xml += `  </url>\n`;

        // Add each category
        categories.forEach((category) => {
            xml += `  <url>\n`;
            xml += `    <loc>${baseUrl}/${category.paramlink}</loc>\n`;
            xml += `    <lastmod>${category.updatedon}</lastmod>\n`;
            xml += `  </url>\n`;
        });

        xml += `</urlset>`;

        return xml;
    };
    const generatePageSitemap = () => {
        console.log("pages:", pages);
        const baseUrl = "https://databeautifier.com";

        let xml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
        xml += `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n`;

        // Add each pages
        pages.forEach((page) => {
            xml += `  <url>\n`;
            xml += `    <loc>${baseUrl}/${page.paramlink}</loc>\n`;
            xml += `    <lastmod>${page.addedon}</lastmod>\n`;
            xml += `  </url>\n`;
        });

        xml += `</urlset>`;

        return xml;
    };
    const handleBlogClick = async (id) => {
        const xmlContent = generateBlogSitemap();
        const blob = new Blob([xmlContent], { type: "application/xml" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sitemap-blogs.xml";
        link.click();
        URL.revokeObjectURL(link.href);
    };

    const handleTagClick = async (id) => {
        const xmlContent = generateTagSitemap();
        const blob = new Blob([xmlContent], { type: "application/xml" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sitemap-tags.xml";
        link.click();
        URL.revokeObjectURL(link.href);
    };
    const handlePageClick = async (id) => {
        const xmlContent = generatePageSitemap();
        const blob = new Blob([xmlContent], { type: "application/xml" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sitemap-tools.xml";
        link.click();
        URL.revokeObjectURL(link.href);
    };
    const handleCategoryClick = async (id) => {
        const xmlContent = generateCategorySitemap();
        const blob = new Blob([xmlContent], { type: "application/xml" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "sitemap-category.xml";
        link.click();
        URL.revokeObjectURL(link.href);
    };

    return (
        <>
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-3">
                                    <p class="card-title mb-0">Generate Sitemaps</p>
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr>
                                            <th>Generate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <button type="submit"
                                                    onClick={(e) => handleBlogClick(e.target.value)}
                                                    className="btn btn-primary me-2">
                                                    Generate Blog Sitemap
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <button type="submit"
                                                    onClick={(e) => handleCategoryClick(e.target.value)}
                                                    className="btn btn-primary me-2">
                                                    Generate Category Sitemap
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <button type="submit"
                                                    onClick={(e) => handlePageClick(e.target.value)}
                                                    className="btn btn-primary me-2">
                                                    Generate Pages Sitemap
                                                </button>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <button type="submit"
                                                    onClick={(e) => handleTagClick(e.target.value)}
                                                    className="btn btn-primary me-2">
                                                    Generate Tag Sitemap
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="bottom-right" reverseOrder={false} />
        </>
    );
}

export default Sitemaps;